"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _button = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/button"));

var _alertBanner = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/alert-banner"));

var _textInput = _interopRequireDefault(require("./text-input"));

var _dropDown = _interopRequireDefault(require("./drop-down"));

var _checkbox = _interopRequireDefault(require("./checkbox"));

var _modalHelper = _interopRequireDefault(require("./modal-helper"));

var _modalContentEin = _interopRequireDefault(require("./modal-helper/modal-content-ein"));

var _validate = _interopRequireDefault(require("./validate"));

var _constants = require("../../constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Form = function Form(_ref) {
  var _ref2;

  var _ref$data = _ref.data,
      taxId = _ref$data.taxId,
      no_taxId_consent = _ref$data.no_taxId_consent,
      addressCountry = _ref$data.addressCountry,
      addressCity = _ref$data.addressCity,
      addressPostalCode = _ref$data.addressPostalCode,
      addressState = _ref$data.addressState,
      addressStreet = _ref$data.addressStreet,
      brandWebsite = _ref$data.brandWebsite,
      businessNameDisplay = _ref$data.businessNameDisplay,
      businessNameLegal = _ref$data.businessNameLegal,
      businessStockExchange = _ref$data.businessStockExchange,
      businessStockSymbol = _ref$data.businessStockSymbol,
      businessType = _ref$data.businessType,
      businessVertical = _ref$data.businessVertical,
      contactEmail = _ref$data.contactEmail,
      contactName = _ref$data.contactName,
      contactPhone = _ref$data.contactPhone,
      dropdownValues = _ref.dropdownValues,
      errorMessage = _ref.errorMessage,
      failed = _ref.failed,
      hasSubmitted = _ref.hasSubmitted,
      isSubmitting = _ref.isSubmitting,
      onCancel = _ref.onCancel,
      onSave = _ref.onSave,
      onSubmit = _ref.onSubmit;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSubmitEnabled = _useState2[0],
      setIsSubmitEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)(addressCountry),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedCountry = _useState4[0],
      setSelectedCountry = _useState4[1];

  var _useState5 = (0, _react.useState)(businessType),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedBusinessType = _useState6[0],
      setSelectedBusinessType = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      currentAction = _useState8[0],
      setCurrentAction = _useState8[1];

  var handleSubmit = function handleSubmit(values) {
    setCurrentAction('SUBMIT');
    onSubmit(values);
  };

  var handleCancel = function handleCancel() {
    setCurrentAction('');
    onCancel();
  };

  var handleSave = function handleSave(values) {
    setCurrentAction('SAVE');
    onSave(values);
  };

  var handleSubmitDisabled = function handleSubmitDisabled(values) {
    !isSubmitting && _validate.default.isValid(values).then(function (result) {
      return setIsSubmitEnabled(result);
    });
  }; // clear the State field error if there is one, after switching countries


  var handleCountrySwitch = function handleCountrySwitch(newSelectedCountry, hasStateFieldError, setFieldError, setFieldTouched) {
    if (newSelectedCountry !== selectedCountry) {
      setSelectedCountry(newSelectedCountry);

      if (hasStateFieldError) {
        setFieldError(_constants.ADDRESS_STATE, '');
        setFieldTouched(_constants.ADDRESS_STATE, false);
      }
    }
  };

  var handleSolePropCheckbox = function handleSolePropCheckbox(touched, values, errors, setFieldError, setFieldTouched) {
    var newBusinessType = values[_constants.BUSINESS_TYPE];

    if (selectedBusinessType !== newBusinessType) {
      if (newBusinessType === _constants.BUSINESS_TYPE_SOLE_PROP && !errors[_constants.NO_TAX_ID_CONSENT]) {
        setFieldError(_constants.NO_TAX_ID_CONSENT, 'Field Required');
        setSelectedBusinessType(newBusinessType);
      }
    }

    if (selectedBusinessType === _constants.BUSINESS_TYPE_SOLE_PROP) {
      if (touched[_constants.BUSINESS_TYPE] && errors[_constants.NO_TAX_ID_CONSENT] && !touched[_constants.NO_TAX_ID_CONSENT]) {
        setFieldTouched(_constants.NO_TAX_ID_CONSENT);
      }
    }
  };

  var setInitialTouched = function setInitialTouched(field, touched, setFieldTouched) {
    !touched[field] && setFieldTouched(field, true);
  };

  var trimSpaces = function trimSpaces(field, value, setFieldValue) {
    setFieldValue(field, value.trim());
  };

  (0, _react.useEffect)(function () {
    if (failed) {
      // if there's an error, scroll so the error banner gets into view
      var alertErrorBanner = document.querySelector('.alertErrorBanner');
      alertErrorBanner && alertErrorBanner.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  }, [failed]);
  return (
    /*#__PURE__*/
    _react.default.createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-30",
      type: "h1"
    }, "10 DLC Registration"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20"
    }, "Enter your business information in the following fields. All fields are required in order to submit your registration."), failed &&
    /*#__PURE__*/
    _react.default.createElement(_alertBanner.default, {
      className: "mb-20 alertErrorBanner",
      message: errorMessage,
      error: true,
      noClose: true
    }),
    /*#__PURE__*/
    _react.default.createElement(_formik.Formik, {
      initialValues: (_ref2 = {}, _defineProperty(_ref2, _constants.BUSINESS_NAME_LEGAL, businessNameLegal), _defineProperty(_ref2, _constants.BUSINESS_NAME_DISPLAY, businessNameDisplay), _defineProperty(_ref2, _constants.BUSINESS_TYPE, businessType), _defineProperty(_ref2, _constants.TAX_ID, taxId), _defineProperty(_ref2, _constants.STOCK_EXCHANGE, businessStockExchange), _defineProperty(_ref2, _constants.STOCK_SYMBOL, businessStockSymbol), _defineProperty(_ref2, _constants.BUSINESS_VERTICAL, businessVertical), _defineProperty(_ref2, _constants.BRAND_WEBSITE, brandWebsite), _defineProperty(_ref2, _constants.ADDRESS_COUNTRY_ID, addressCountry), _defineProperty(_ref2, _constants.ADDRESS_STATE, addressState), _defineProperty(_ref2, _constants.ADDRESS_CITY, addressCity), _defineProperty(_ref2, _constants.ADDRESS_POSTAL_CODE, addressPostalCode), _defineProperty(_ref2, _constants.ADDRESS_STREET, addressStreet), _defineProperty(_ref2, _constants.CONTACT_PHONE, contactPhone), _defineProperty(_ref2, _constants.CONTACT_NAME, contactName), _defineProperty(_ref2, _constants.CONTACT_EMAIL, contactEmail), _defineProperty(_ref2, _constants.NO_TAX_ID_CONSENT, no_taxId_consent), _ref2),
      onSubmit: handleSubmit,
      validateOnBlur: false,
      validationSchema: _validate.default,
      render: function render(_ref3) {
        var errors = _ref3.errors,
            handleChange = _ref3.handleChange,
            setFieldError = _ref3.setFieldError,
            setFieldValue = _ref3.setFieldValue,
            setFieldTouched = _ref3.setFieldTouched,
            values = _ref3.values,
            touched = _ref3.touched;
        handleSubmitDisabled(values);
        handleCountrySwitch(values[_constants.ADDRESS_COUNTRY_ID], errors[_constants.ADDRESS_STATE], setFieldError, setFieldTouched);
        handleSolePropCheckbox(touched, values, errors, setFieldError, setFieldTouched);
        return (
          /*#__PURE__*/
          _react.default.createElement("div", {
            className: "".concat(_constants.STYLE_BASE, "_formContainer")
          },
          /*#__PURE__*/
          _react.default.createElement("div", {
            className: "".concat(_constants.STYLE_BASE, "_formSectionHeader mb-30")
          },
          /*#__PURE__*/
          _react.default.createElement(_styledText.default, {
            type: "h2"
          }, "Business Info"),
          /*#__PURE__*/
          _react.default.createElement(_styledText.default, {
            secondary: true
          }, "All fields required")),
          /*#__PURE__*/
          _react.default.createElement(_dropDown.default, {
            error: touched[_constants.BUSINESS_TYPE] && errors[_constants.BUSINESS_TYPE],
            fieldName: _constants.BUSINESS_TYPE,
            label: "Business Type",
            items: dropdownValues[_constants.LOOKUP_KEY_BUSINESS_TYPE],
            placeholder: (0, _utils.getDropdownDefaultLabel)(dropdownValues[_constants.LOOKUP_KEY_BUSINESS_TYPE], values[_constants.BUSINESS_TYPE]) || 'Select one',
            setFieldTouched: setFieldTouched,
            setFieldValue: setFieldValue,
            selectedValue: values[_constants.BUSINESS_TYPE],
            testid: "DROPDOWN_BUSINESS_TYPE"
          }), values[_constants.BUSINESS_TYPE] !== _constants.BUSINESS_TYPE_SOLE_PROP ?
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.TAX_ID] && errors[_constants.TAX_ID],
            description:
            /*#__PURE__*/
            _react.default.createElement("span", null, "A nine-digit number used to identify your business for tax reporting. Do not include SSN in this field.", ' ',
            /*#__PURE__*/
            _react.default.createElement(_modalHelper.default, {
              openerText: "Help me find my EIN or Canadian BN",
              content:
              /*#__PURE__*/
              _react.default.createElement(_modalContentEin.default, null)
            })),
            id: _constants.TAX_ID,
            label: "EIN (Canadian BN for Canada)",
            name: _constants.TAX_ID,
            onBlur: function onBlur() {
              return trimSpaces(_constants.TAX_ID, values[_constants.TAX_ID], setFieldValue);
            },
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.TAX_ID, touched, setFieldTouched);
            },
            placeholder: "xx-xxxxxxxx",
            testid: "INPUT_TAX_ID",
            touched: touched[_constants.TAX_ID],
            value: values[_constants.TAX_ID]
          }) :
          /*#__PURE__*/
          _react.default.createElement(_checkbox.default, {
            name: _constants.NO_TAX_ID_CONSENT,
            value: values[_constants.NO_TAX_ID_CONSENT],
            label: "By checking this box, I verify that my company is not registered to do business with an EIN or Canadian BN.",
            onChange: function onChange(val) {
              setFieldValue(_constants.NO_TAX_ID_CONSENT, val);
              setFieldError(_constants.NO_TAX_ID_CONSENT, !val);
            },
            error: errors[_constants.NO_TAX_ID_CONSENT],
            testid: "CHECKBOX_NO_TAX_ID_CONSENT",
            touched: touched[_constants.NO_TAX_ID_CONSENT]
          }), values[_constants.BUSINESS_TYPE] === _constants.BUSINESS_TYPE_PUBLIC &&
          /*#__PURE__*/
          _react.default.createElement(_react.Fragment, null,
          /*#__PURE__*/
          _react.default.createElement(_dropDown.default, {
            error: touched[_constants.STOCK_EXCHANGE] && errors[_constants.STOCK_EXCHANGE],
            description: "The exchange where your company\u2019s public stock is traded (ex: NASDAQ).",
            fieldName: _constants.STOCK_EXCHANGE,
            label: "Stock Exchange",
            items: dropdownValues[_constants.LOOKUP_KEY_STOCK_EXCHANGE],
            placeholder: values[_constants.STOCK_EXCHANGE] || 'Select one',
            setFieldTouched: setFieldTouched,
            setFieldValue: setFieldValue,
            selectedValue: values[_constants.STOCK_EXCHANGE],
            testid: "DROPDOWN_STOCK_EXCHANGE"
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.STOCK_SYMBOL] && errors[_constants.STOCK_SYMBOL],
            description: "The shorthand symbol used to identify your company\u2019s stock (ex: AAPL).",
            id: _constants.STOCK_SYMBOL,
            label: "Stock Symbol",
            name: _constants.STOCK_SYMBOL,
            onBlur: function onBlur() {
              return trimSpaces(_constants.STOCK_SYMBOL, values[_constants.STOCK_SYMBOL], setFieldValue);
            },
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.STOCK_SYMBOL, touched, setFieldTouched);
            },
            testid: "INPUT_STOCK_SYMBOL",
            touched: touched[_constants.STOCK_SYMBOL],
            value: values[_constants.STOCK_SYMBOL]
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.BRAND_WEBSITE] && errors[_constants.BRAND_WEBSITE],
            id: _constants.BRAND_WEBSITE,
            label: "Business Website",
            name: _constants.BRAND_WEBSITE,
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.BRAND_WEBSITE, touched, setFieldTouched);
            },
            testid: "INPUT_BRAND_WEBSITE",
            touched: touched[_constants.BRAND_WEBSITE],
            value: values[_constants.BRAND_WEBSITE]
          })),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.BUSINESS_NAME_LEGAL] && errors[_constants.BUSINESS_NAME_LEGAL],
            description: "The legal name for the business that matches your company\u2019s tax or legal incorporation documents.",
            id: _constants.BUSINESS_NAME_LEGAL,
            label: "Legal Business Name",
            name: _constants.BUSINESS_NAME_LEGAL,
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.BUSINESS_NAME_LEGAL, touched, setFieldTouched);
            },
            placeholder: "Company Name, Inc",
            testid: "INPUT_BUSINESS_NAME_LEGAL",
            touched: touched[_constants.BUSINESS_NAME_LEGAL],
            value: values[_constants.BUSINESS_NAME_LEGAL]
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.BUSINESS_NAME_DISPLAY] && errors[_constants.BUSINESS_NAME_DISPLAY],
            description: "The operating name of your company used in marketing materials and non-legal documents.",
            id: _constants.BUSINESS_NAME_DISPLAY,
            label: "Business Name",
            name: _constants.BUSINESS_NAME_DISPLAY,
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.BUSINESS_NAME_DISPLAY, touched, setFieldTouched);
            },
            placeholder: "Company Name",
            testid: "INPUT_BUSINESS_NAME_DISPLAY",
            touched: touched[_constants.BUSINESS_NAME_DISPLAY],
            value: values[_constants.BUSINESS_NAME_DISPLAY]
          }),
          /*#__PURE__*/
          _react.default.createElement(_dropDown.default, {
            error: touched[_constants.BUSINESS_VERTICAL] && errors[_constants.BUSINESS_VERTICAL],
            description: "The option that most closely describes the audience and set of needs served by your company.",
            fieldName: _constants.BUSINESS_VERTICAL,
            label: "Industry or Vertical",
            items: (0, _utils.getSortedBusinessVerticals)(dropdownValues[_constants.LOOKUP_KEY_BUSINESS_VERTICAL]),
            placeholder: (0, _utils.getDropdownDefaultLabel)(dropdownValues[_constants.LOOKUP_KEY_BUSINESS_VERTICAL], values[_constants.BUSINESS_VERTICAL]) || 'Select one',
            setFieldTouched: setFieldTouched,
            setFieldValue: setFieldValue,
            selectedValue: values[_constants.BUSINESS_VERTICAL],
            testid: "DROPDOWN_BUSINESS_VERTICAL"
          }),
          /*#__PURE__*/
          _react.default.createElement(_styledText.default, {
            type: "h2",
            className: "pt-10 mb-20"
          }, "Business Location"),
          /*#__PURE__*/
          _react.default.createElement(_dropDown.default, {
            error: touched[_constants.ADDRESS_COUNTRY_ID] && errors[_constants.ADDRESS_COUNTRY_ID],
            fieldName: _constants.ADDRESS_COUNTRY_ID,
            label: "Country",
            items: _constants.COUNTRY_OPTIONS,
            placeholder: (0, _utils.getDropdownDefaultLabel)(_constants.COUNTRY_OPTIONS, values[_constants.ADDRESS_COUNTRY_ID]) || 'United States' // TODO: FIX show the default value
            ,
            setFieldTouched: setFieldTouched,
            setFieldValue: setFieldValue,
            selectedValue: values[_constants.ADDRESS_COUNTRY_ID] || 'US',
            testid: "DROPDOWN_COUNTRY_ID"
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.ADDRESS_STREET] && errors[_constants.ADDRESS_STREET],
            id: _constants.ADDRESS_STREET,
            label: "Company Address",
            name: _constants.ADDRESS_STREET,
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.ADDRESS_STREET, touched, setFieldTouched);
            },
            placeholder: "Street address or P.O. Box",
            testid: "INPUT_ADDRESS_STREET",
            touched: touched[_constants.ADDRESS_STREET],
            value: values[_constants.ADDRESS_STREET]
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.ADDRESS_CITY] && errors[_constants.ADDRESS_CITY],
            id: _constants.ADDRESS_CITY,
            label: "City",
            name: _constants.ADDRESS_CITY,
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.ADDRESS_CITY, touched, setFieldTouched);
            },
            testid: "INPUT_ADDRESS_CITY",
            touched: touched[_constants.ADDRESS_CITY],
            value: values[_constants.ADDRESS_CITY]
          }),
          /*#__PURE__*/
          _react.default.createElement("div", {
            className: "inputsRow"
          },
          /*#__PURE__*/
          _react.default.createElement("div", null,
          /*#__PURE__*/
          _react.default.createElement(_dropDown.default, {
            error: touched[_constants.ADDRESS_STATE] && errors[_constants.ADDRESS_STATE],
            fieldName: _constants.ADDRESS_STATE,
            label: values[_constants.ADDRESS_COUNTRY_ID] === 'US' ? 'State' : 'Province',
            items: values[_constants.ADDRESS_COUNTRY_ID] === 'US' ? _constants.US_STATES_OPTIONS : _constants.CANADIAN_PROVINCES_OPTIONS,
            placeholder: (0, _utils.getDropdownDefaultLabel)(values[_constants.ADDRESS_COUNTRY_ID] === 'US' ? _constants.US_STATES_OPTIONS : _constants.CANADIAN_PROVINCES_OPTIONS, values[_constants.ADDRESS_STATE]) || 'Select one',
            setFieldTouched: setFieldTouched,
            setFieldValue: setFieldValue,
            selectedValue: values[_constants.ADDRESS_STATE],
            testid: "DROPDOWN_ADDRESS_STATE"
          })),
          /*#__PURE__*/
          _react.default.createElement("div", null,
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.ADDRESS_POSTAL_CODE] && errors[_constants.ADDRESS_POSTAL_CODE],
            id: _constants.ADDRESS_POSTAL_CODE,
            label: values[_constants.ADDRESS_COUNTRY_ID] === 'US' ? 'ZIP Code' : 'Postal Code',
            name: _constants.ADDRESS_POSTAL_CODE,
            onBlur: function onBlur() {
              return trimSpaces(_constants.ADDRESS_POSTAL_CODE, values[_constants.ADDRESS_POSTAL_CODE], setFieldValue);
            },
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.ADDRESS_POSTAL_CODE, touched, setFieldTouched);
            },
            testid: "INPUT_ADDRESS_POSTAL_CODE",
            touched: touched[_constants.ADDRESS_POSTAL_CODE],
            value: values[_constants.ADDRESS_POSTAL_CODE]
          }))),
          /*#__PURE__*/
          _react.default.createElement(_styledText.default, {
            type: "h2",
            className: "pt-10 mb-20"
          }, "Contact Info"),
          /*#__PURE__*/
          _react.default.createElement(_styledText.default, {
            className: "mb-20"
          }, "We may contact you with follow-up questions or additional information."),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.CONTACT_NAME] && errors[_constants.CONTACT_NAME],
            id: _constants.CONTACT_NAME,
            label: "Contact Name",
            name: _constants.CONTACT_NAME,
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.CONTACT_NAME, touched, setFieldTouched);
            },
            testid: "INPUT_CONTACT_NAME",
            touched: touched[_constants.CONTACT_NAME],
            value: values[_constants.CONTACT_NAME]
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.CONTACT_PHONE] && errors[_constants.CONTACT_PHONE],
            id: _constants.CONTACT_PHONE,
            label: "Contact Phone",
            name: _constants.CONTACT_PHONE,
            onBlur: function onBlur() {
              return trimSpaces(_constants.CONTACT_PHONE, values[_constants.CONTACT_PHONE], setFieldValue);
            },
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.CONTACT_PHONE, touched, setFieldTouched);
            },
            placeholder: "12345678900",
            testid: "INPUT_CONTACT_PHONE",
            touched: touched[_constants.CONTACT_PHONE],
            value: values[_constants.CONTACT_PHONE]
          }),
          /*#__PURE__*/
          _react.default.createElement(_textInput.default, {
            error: touched[_constants.CONTACT_EMAIL] && errors[_constants.CONTACT_EMAIL],
            id: _constants.CONTACT_EMAIL,
            label: "Contact Email",
            name: _constants.CONTACT_EMAIL,
            onBlur: function onBlur() {
              return trimSpaces(_constants.CONTACT_EMAIL, values[_constants.CONTACT_EMAIL], setFieldValue);
            },
            onChange: handleChange,
            onInput: function onInput() {
              return setInitialTouched(_constants.CONTACT_EMAIL, touched, setFieldTouched);
            },
            placeholder: "name@myemail.com",
            testid: "INPUT_CONTACT_EMAIL",
            touched: touched[_constants.CONTACT_EMAIL],
            value: values[_constants.CONTACT_EMAIL]
          }),
          /*#__PURE__*/
          _react.default.createElement("div", {
            className: "".concat(_constants.STYLE_BASE, "_actionsRow")
          },
          /*#__PURE__*/
          _react.default.createElement(_react.Fragment, null,
          /*#__PURE__*/
          _react.default.createElement(_button.default, {
            disabled: isSubmitting,
            className: "".concat(_constants.STYLE_BASE, "_cancelButton"),
            onClick: handleCancel,
            secondary: true,
            testid: "10DLC_FORM_CANCEL_BUTTON"
          }, "Cancel"), !hasSubmitted &&
          /*#__PURE__*/
          _react.default.createElement(_button.default, {
            disabled: isSubmitting,
            className: "".concat(_constants.STYLE_BASE, "_saveButton"),
            loading: isSubmitting && currentAction === 'SAVE',
            onClick: function onClick() {
              return handleSave(values);
            },
            secondary: true,
            testid: "10DLC_FORM_SAVE_BUTTON"
          }, "Save"),
          /*#__PURE__*/
          _react.default.createElement(_button.default, {
            disabled: !isSubmitEnabled,
            className: "".concat(_constants.STYLE_BASE, "_submitButton"),
            loading: isSubmitting && currentAction === 'SUBMIT',
            onClick: function onClick() {
              return handleSubmit(values);
            },
            testid: "10DLC_FORM_SUBMIT_BUTTON"
          }, hasSubmitted ? 'Update Submission' : 'Submit'))))
        );
      }
    }))
  );
};

var _default = Form;
exports.default = _default;